// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__sHJYh","play":"Video_play__mGo5g","container":"Video_container__lpRV0","reactPlayer":"Video_reactPlayer__Chh34"};